import { render, staticRenderFns } from "./AddDisclaimer.vue?vue&type=template&id=3216f86f&scoped=true"
var script = {}
import style0 from "./AddDisclaimer.vue?vue&type=style&index=0&id=3216f86f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3216f86f",
  null
  
)

export default component.exports